import { closeDialog } from '@redux/reducers/dialogWindowManager.reducer'
import { store } from '@redux/store'

import { CriteriaType } from '@constants'
import { GETSearchType } from '@types'

import {
  disposeSearchAssistant,
  saveCriterias,
  saveDefaultSearchFilter,
  saveSelectedFavouriteCriteria,
} from '../store/search-assistant.slice'

class SearchAssistantRepository {
  constructor(private searchAssistantKey: string | undefined) {}

  public saveDefaultSearchFilter(defaultSearchFilter: GETSearchType | null) {
    if (!this.searchAssistantKey) {
      return
    }

    store.dispatch(
      saveDefaultSearchFilter({
        searchAssistantKey: this.searchAssistantKey,
        defaultSearchFilter,
      })
    )
  }

  public saveSelectedFavouriteCriteria(selectedFavouriteCriteria: GETSearchType | null) {
    if (!this.searchAssistantKey) {
      return
    }

    store.dispatch(
      saveSelectedFavouriteCriteria({
        searchAssistantKey: this.searchAssistantKey,
        selectedFavouriteCriteria,
      })
    )
  }

  public saveCriterias(criterias: CriteriaType[]) {
    if (!this.searchAssistantKey) {
      return []
    }

    store.dispatch(
      saveCriterias({
        searchAssistantKey: this.searchAssistantKey,
        criterias,
      })
    )
  }

  public closeFilterManager(dialogId: string) {
    store.dispatch(closeDialog({ id: dialogId }))
  }

  public disposeSearchAssistant() {
    store.dispatch(disposeSearchAssistant({ searchAssistantKey: this.searchAssistantKey }))
  }
}

export { SearchAssistantRepository }
